// extracted by mini-css-extract-plugin
export default {"root":"WiseProductTabs_root__PHvXP","tabsRoot":"WiseProductTabs_tabsRoot__-WwNZ","indicator":"WiseProductTabs_indicator__-C-7r","tabRoot":"WiseProductTabs_tabRoot__Wn1bC"};